<template>
  <label>
    <input type="checkbox" @change="$emit('input', $event.target.checked)" />
    {{ text }}
  </label>
</template>

<script>
export default {
  name: "VCheckBox",
  props: {
    text: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
label {
  align-items: center;
  display: flex;
  margin: 0 5px;
}
input {
  appearance: none;
  height: 20px;
  margin-right: 5px;
  overflow: visible;
  width: 20px;

  &:checked {
    background-color: $gray;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='8 8 36 36' version='1.1' xml:space='preserve'><path d='M14.1 27.2l7.1 7.2 16.7-16.8' fill='none' stroke='rgba(255,255,255,1)' stroke-width='5'/></svg>");
  }
}
</style>
